import axios from "axios";
const axiosToken = axios.create({
    baseURL: 'https://backend.mafert.com'
});
export default axiosToken;